function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { Checkbox, RadioLabelLarge } from "../";
export const CheckboxLarge = ({
  children,
  checked,
  disabled,
  ...props
}) => {
  return React.createElement(RadioLabelLarge, {
    disabled: disabled,
    checked: checked
  }, React.createElement(Checkbox, _extends({
    disabled: disabled,
    checked: checked
  }, props), children));
};